import { render, staticRenderFns } from "./PrintBargeSaham.vue?vue&type=template&id=c4033346&scoped=true&"
import script from "./PrintBargeSaham.vue?vue&type=script&lang=js&"
export * from "./PrintBargeSaham.vue?vue&type=script&lang=js&"
import style0 from "./PrintBargeSaham.vue?vue&type=style&index=0&id=c4033346&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4033346",
  null
  
)

export default component.exports